import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  // DATA
  entityList: null,
  tanListByEntity: {},
  allocationStatusList: [],
  quarterTypeList:[],
  returnTypeList:[],

  // SELECTIONS
  selectedEntityUuid: '',
  selectedTANUuid: '',
  selectedTANUuids: [],
  selectedYear: '',
  selectedMonth: [],
  selectedAllocateFY:[],
  selectStatus: '',
  selectAllocateStatus: '',
  selectQuarter: '',
  selectReturnType: '',
  selectForm: '',

  // LOADING STATES
  entityLoading: false,
  tanLoading: false,
  allocationStatusLoading: false,
  quarterTypeStatusLoding:false,
  returnTypeStatusLoading:false,

  // ERROR STATES
  entityError: null,
  tanError: null,
  allocationStatusError: null,
  quarterTypeStatusError:null,
  returnTypeStatusError:null,
}

const entityTanSlice = createSlice({
  name: 'entityTan',
  initialState,
  reducers: {
    // ================= ENTITY =================
    fetchEntityStart: state => {
      state.entityLoading = true
      state.entityError = null
    },
    fetchEntitySuccess: (state, action) => {
      state.entityLoading = false
      state.entityList = action.payload
    },
    fetchEntityFailure: (state, action) => {
      state.entityLoading = false
      state.entityError = action.payload
    },

    // ================= TAN =================
    fetchTanStart: state => {
      state.tanLoading = true
      state.tanError = null
    },
    fetchTanSuccess: (state, action) => {
      const { entityUuid, tanList } = action.payload
      state.tanLoading = false
      state.tanListByEntity[entityUuid] = tanList
    },
    fetchTanFailure: (state, action) => {
      state.tanLoading = false
      state.tanError = action.payload
    },

    // ================= ALLOCATION STATUS =================
    fetchAllocationStatusStart: state => {
      state.allocationStatusLoading = true
      state.allocationStatusError = null
    },
    fetchAllocationStatusSuccess: (state, action) => {
      state.allocationStatusLoading = false
      state.allocationStatusList = action.payload
    },
    fetchAllocationStatusFailure: (state, action) => {
      state.allocationStatusLoading = false
      state.allocationStatusError = action.payload
    },

    // ================= Quarter TYPE =================
    fetchQuarterStatusStart: state => {
      state.quarterTypeStatusLoding = true
      state.quarterTypeStatusError = null
    },
    fetchQuarterStatusSuccess: (state, action) => {
      state.quarterTypeStatusLoding = false
      state.quarterTypeList = action.payload
    },
    fetchQuarterStatusFailure: (state, action) => {
      state.quarterTypeStatusLoding = false
      state.quarterTypeStatusError = action.payload
    },

      // ================= Return TYPE =================
    fetchReturnStatusStart: state => {
      state.returnTypeStatusLoading = true
      state.returnTypeStatusError = null
    },
    fetchReturnStatusSuccess: (state, action) => {
      state.returnTypeStatusLoading = false
      state.returnTypeList = action.payload
    },
    fetchReturnStatusFailure: (state, action) => {
      state.returnTypeStatusLoading = false
      state.returnTypeStatusError = action.payload
    },

    // ================= SELECTIONS =================
    setSelectedEntity: (state, action) => {
      state.selectedEntityUuid = action.payload
      state.selectedTANUuid = '' // reset TAN on entity change
      state.selectedTANUuids = [] // reset multi TAN on entity change
    },
    setSelectedTAN: (state, action) => {
      state.selectedTANUuid = action.payload
    },
    setSelectedTANs: (state, action) => {
      state.selectedTANUuids = action.payload
    },
    setSelectedYear: (state, action) => {
      state.selectedYear = action.payload
    },
    setSelectedMonth: (state, action) => {
      state.selectedMonth = action.payload
    },
    setSelectedAllocateFY:(state, action) => {
      state.selectedAllocateFY = action.payload
    },
    setSelectedStatus: (state, action) => {
      state.selectStatus = action.payload
    },
    setSelectedAllocateStatus: (state, action) => {
      state.selectAllocateStatus = action.payload
    },
    setSelectedQuarter: (state, action) => {
      state.selectQuarter = action.payload
    },
    setSelectedReturnType: (state, action) => {
      state.selectReturnType = action.payload
    },
    setSelectedForm: (state, action) => {
      state.selectForm = action.payload
    },

    // ================= RESET =================
    resetMonth: state => {
      state.selectedMonth = []
    },
    resetSelections: state => {
      state.selectedEntityUuid = ''
      state.selectedTANUuid = ''
      state.selectedTANUuids = []
      state.selectedYear = ''
      state.selectedMonth = []
      state.selectedAllocateFY = []
      state.selectStatus = ''
      state.selectAllocateStatus = ''
      state.selectQuarter = ''
      state.selectReturnType = ''
      state.selectForm = ''
    },
    resetEntityTanState: () => initialState,
    clearEntityList: state => {
      state.entityList = null
    },
  },
})

export const {
  fetchEntityStart,
  fetchEntitySuccess,
  fetchEntityFailure,

  fetchTanStart,
  fetchTanSuccess,
  fetchTanFailure,

  fetchAllocationStatusStart,
  fetchAllocationStatusSuccess,
  fetchAllocationStatusFailure,

  fetchQuarterStatusStart,
  fetchQuarterStatusSuccess,
  fetchQuarterStatusFailure,

  fetchReturnStatusStart,
  fetchReturnStatusSuccess,
  fetchReturnStatusFailure,

  setSelectedEntity,
  setSelectedTAN,
  setSelectedTANs,
  setSelectedYear,
  setSelectedMonth,
  setSelectedAllocateFY,
  setSelectedStatus,
  setSelectedAllocateStatus,
  setSelectedQuarter,
  setSelectedReturnType,
  setSelectedForm,

  resetSelections,
  resetEntityTanState,
  resetMonth,
  clearEntityList,
} = entityTanSlice.actions

export default entityTanSlice.reducer
